import { FullAudit, IsActiveFlag } from '@/types';

export interface ContactPhoneNumberModel extends IsActiveFlag, FullAudit {
    id: number;
    levelId: number;
    contactId: number;
    number: string;
    isMain: boolean;
}
